import {
  PHOTO_TYPE_FACE,
  PHOTO_TYPE_TONGUE,
  RESET_PHOTO_STATE_ACTION,
  SET_ANALYSIS_RESULT,
  SET_GUIDANCE_VISIBILITY,
  SET_PHOTO_PREVIEW_OFFSET,
  SET_PHOTO_PREVIEW_ZOOM,
  SET_PHOTO_UPLOADED,
  SET_PREVIEW_PHOTO,
} from '../actions/photo';
import { createReducer } from './util';

const initialPreviewOptions = {
  x: 0,
  y: 0,
  lastX: 0,
  lastY: 0,
  zoom: 1.2,
  lastZoom: 1.2,
};

export const photoInitialState = {
  photo: {
    [PHOTO_TYPE_FACE]: null,
    [PHOTO_TYPE_TONGUE]: null,
    facePhotoUploaded: false,
    tonguePhotoUploaded: false,
    faceGuidance: false,
    tongueGuidance: false,
    faceUnrecognizable: false,
    tongueUnrecognizable: false,
    showGuidance: false,
    guidanceType: null,
    guidanceIsError: false,
    previewOptions: {
      [PHOTO_TYPE_FACE]: { ...initialPreviewOptions },
      [PHOTO_TYPE_TONGUE]: { ...initialPreviewOptions },
    }
  }
};

export const photo = createReducer(
  photoInitialState.photo,
  {
    [SET_PREVIEW_PHOTO]: (_, action) => ({ [action.photoType]: action.src }),
    [SET_ANALYSIS_RESULT]: (_, action) => ({
      [`${action.photoType}Unrecognizable`]: action.unrecognizable,
    }),
    [SET_GUIDANCE_VISIBILITY]: (state, { photoType, on }) => ({
      showGuidance: on,
      guidanceIsError: state[`${photoType}Unrecognizable`],
      guidanceType: photoType,
      [`${photoType}Guidance`]: on,
    }),
    [SET_PHOTO_UPLOADED]: (_, { photoType, uploaded }) => ({
      [`${photoType}PhotoUploaded`]: uploaded,
    }),
    [SET_PHOTO_PREVIEW_ZOOM]: (state, { photoType, zoom, last }) => ({
      previewOptions: {
        ...state.previewOptions,
        [photoType]: {
          ...state.previewOptions[photoType],
          zoom,
          lastZoom: last ? zoom : state.previewOptions[photoType].lastZoom,
        }
      },
    }),
    [SET_PHOTO_PREVIEW_OFFSET]: (state, {
      photoType, x, y, last
    }) => ({
      previewOptions: {
        ...state.previewOptions,
        [photoType]: {
          ...state.previewOptions[photoType],
          x, y,
          lastX: last ? x : state.previewOptions[photoType].lastX,
          lastY: last ? y : state.previewOptions[photoType].lastY,
        }
      },
    }),
    [RESET_PHOTO_STATE_ACTION]: ({ previewOptions }, { photoType }) => {
      const state = {};
      Object.entries(photoInitialState.photo).map(([k, v]) => {
        if (k.startsWith(photoType)) state[k] = v;
        return null;
      });
      state.previewOptions = {
        ...previewOptions,
        [photoType]: { ...initialPreviewOptions },
      };
      return state;
    },
  },
);



// WEBPACK FOOTER //
// ./src/reducers/photo.js